export const cards = [
  {
    id: '01',
    title: 'Simulação',
    description:
      'Simule o crédito que você precisa pelo nosso simulador. Basta preencher alguns campos e pronto! Leva só 3 minutos.'
  },
  {
    id: '02',
    title: 'Avaliação',
    description:
      'Vamos fazer uma análise do seu perfil e do seu imóvel, de maneira segura e rápida. Assim, conseguimos oferecer a melhor solução para você.'
  },
  {
    id: '03',
    title: 'Assinatura',
    description:
      'Depois do crédito aprovado, providenciamos os documentos para você e os emitimos para a sua assinatura.'
  },
  {
    id: '04',
    title: 'Dinheiro liberado',
    description: 'Com tudo certo, é hora de assinar o contrato e receber o seu dinheiro!'
  }
]
